// btx synthesizes "awaiting quote" placeholder plans with ids prefixed this way
// (placeholder_synthesis.go). They have no real proposal_plan row.
export const PLACEHOLDER_PLAN_ID_PREFIX = "placeholder-";

export const REQUESTED_CARRIER_ID = "requested";
// The single-group case reads a resolved label from formatRequestedColumnLabel
// instead (per policyPeriod/incumbent carrier) — this literal only surfaces as
// the aggregate carrierName when several requested source groups are bundled
// together (the Unmapped Plans page). The carrier grid then splits those apart
// per group in buildCarrierGroupedColumns.ts, so this placeholder never
// reaches that column header; the rates/summary grid has no equivalent split,
// so there this text can still render as-is for that multi-group case.
export const REQUESTED_CARRIER_NAME = "Incumbent/Requested";

// The Incumbent/Requested column has no rates to edit and no plan of its own
// to manage via the column header menu.
export const READ_ONLY_CARRIER_IDS = [REQUESTED_CARRIER_ID];
